import { paperClasses, Theme } from '@mui/material';

export default function Paper(theme: Theme) {
  return {
    MuiPaper: {
      defaultProps: {
        elevation: 0,
      },
      styleOverrides: {
        root: {
          borderRadius: '5px',
          backgroundColor: '#fff',

          [`&.${paperClasses.outlined}`]: {
            border: `1px solid ${theme.palette.grey[300]}`,
          },
        },
      },
    },
  };
}
